/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Load_From_DurationInputs */

const en_ui_more_stats_load_from_duration = /** @type {(inputs: Ui_More_Stats_Load_From_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rough guess from duration – intensity unknown`)
};

const de_ui_more_stats_load_from_duration = /** @type {(inputs: Ui_More_Stats_Load_From_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grob geschätzt aus der Dauer – Intensität unbekannt`)
};

/**
* | output |
* | --- |
* | "Rough guess from duration – intensity unknown" |
*
* @param {Ui_More_Stats_Load_From_DurationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_load_from_duration = /** @type {((inputs?: Ui_More_Stats_Load_From_DurationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Load_From_DurationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_load_from_duration(inputs)
	return de_ui_more_stats_load_from_duration(inputs)
});